import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
}), 'SkipNext');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SkipNext.js
// module id = 6263
// module chunks = 2